import api from "../index";
import { qs } from "../../utils/utils.js";

export const GetAllTutorialsApi = (params) => api.get(`tutorialmaster/get-all?${qs(params)}`);